import PropTypes from "prop-types"
import React from "react"

import {
  getCurrencyLocaleValue,
  getPercentageLocaleValue,
} from "data/utils/formaters"

import gridStyles from "../../../components/Plans.module.css"

const Commission = ({
  commission,
  isDiscountApplied,
  lang,
  price,
  isLastCommission,
}) => {
  const formattedValue =
    commission.unit === "percent"
      ? getPercentageLocaleValue({
        language: lang,
        value: commission.value || 0,
      })
      : getCurrencyLocaleValue({
        language: lang,
        currency: price.currency,
        value: commission.value || 0,
      })
  return (
    <>
      <p className={`${gridStyles.currency} fs-21 w600`}>{formattedValue}</p>
      {!isLastCommission && (
        <p
          className={`${isDiscountApplied
              ? "fs-14 w300"
              : `${gridStyles.currency} fs-21 w600`
            } m-l-5 m-r-5`}
        >
          +
        </p>
      )}
    </>
  )
}

Commission.propTypes = {
  isDiscountApplied: PropTypes.bool,
  price: PropTypes.object,
  lang: PropTypes.string,
  commission: PropTypes.object,
  isLastCommission: PropTypes.bool,
}
Commission.defaultProps = {
  price: {},
  isDiscountApplied: false,
  lang: "en",
  commission: {},
  isLastCommission: false,
}

export default Commission
